// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { motion, AnimatePresence, useMotionValue, useSpring } from 'framer-motion';
// import {
//   FiPackage, FiFileText, FiRefreshCw, FiPercent,
//   FiUpload, FiClock, FiAlertCircle,
// } from 'react-icons/fi';
// import { getDashboard } from '../../utils/grirApi';

// const formatDate = (str) => {
//   if (!str) return '—';
//   return new Date(str).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
// };
// const formatSize = (bytes) => {
//   if (!bytes) return '—';
//   return bytes > 1024 ? `${(bytes / 1024).toFixed(1)} KB` : `${bytes} B`;
// };

// /* Count-up animated number component */
// const AnimatedCount = ({ target, isFloat = false }) => {
//   const mv = useMotionValue(0);
//   const spring = useSpring(mv, { stiffness: 100, damping: 30, mass: 0.8 });
//   const [display, setDisplay] = useState('0');
//   const ref = useRef(false);

//   useEffect(() => {
//     if (!ref.current) {
//       ref.current = true;
//       const t = parseFloat(target) || 0;
//       mv.set(t);
//     }
//   }, [target, mv]);

//   useEffect(() => {
//     return spring.on('change', (v) => {
//       setDisplay(isFloat ? v.toFixed(2) : Math.round(v).toLocaleString());
//     });
//   }, [spring, isFloat]);

//   return <span>{display}</span>;
// };

// /* Stagger container */
// const containerVariants = {
//   hidden: {},
//   visible: { transition: { staggerChildren: 0.08 } },
// };
// const cardVariants = {
//   hidden:  { opacity: 0, y: 24, scale: 0.96 },
//   visible: { opacity: 1, y: 0,  scale: 1, transition: { type: 'spring', stiffness: 220, damping: 22 } },
// };
// const rowVariants = {
//   hidden:  { opacity: 0, x: -12 },
//   visible: { opacity: 1, x: 0,  transition: { type: 'spring', stiffness: 200, damping: 24 } },
// };

// const GRIRDashboard = ({ onNavigate }) => {
//   const [data, setData]       = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError]     = useState('');

//   const load = useCallback(() => {
//     setLoading(true);
//     setError('');
//     getDashboard()
//       .then(setData)
//       .catch((err) => setError(err.message))
//       .finally(() => setLoading(false));
//   }, []);

//   useEffect(() => { load(); }, [load]);

//   if (loading) {
//     return (
//       <div className="grir-loading">
//         <div className="grir-spinner" />
//         <span>Loading dashboard…</span>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="grir-error">
//         <FiAlertCircle size={28} />
//         <span>{error}</span>
//         <button onClick={load}>Retry</button>
//       </div>
//     );
//   }

//   if (!data) return null;

//   const rate = parseFloat(data.reconciliation_rate) || 0;
//   const stats = [
//     { label: 'Total GR Records',   value: data.total_gr_records,      icon: <FiPackage size={21} />,   color: '#5b5fc7', bg: 'rgba(91,95,199,0.12)',   isFloat: false },
//     { label: 'Total IR Records',   value: data.total_ir_records,      icon: <FiFileText size={21} />,  color: '#0099b0', bg: 'rgba(0,153,176,0.12)',   isFloat: false },
//     { label: 'Reconciliation Runs',value: data.total_reconciliations, icon: <FiRefreshCw size={21} />, color: '#7c3aed', bg: 'rgba(124,58,237,0.12)',  isFloat: false },
//     { label: 'Match Rate',         value: rate,                        icon: <FiPercent size={21} />,   color: '#059669', bg: 'rgba(5,150,105,0.12)',   isFloat: true,  suffix: '%' },
//   ];

//   return (
//     <div className="grir-dashboard">
//       {/* ── Stat cards ── */}
//       <motion.div
//         className="grir-stats-grid"
//         variants={containerVariants}
//         initial="hidden"
//         animate="visible"
//       >
//         {stats.map((s) => (
//           <motion.div key={s.label} className="grir-stat-card" variants={cardVariants}>
//             <div className="grir-stat-icon" style={{ background: s.bg, color: s.color }}>
//               {s.icon}
//             </div>
//             <div className="grir-stat-info">
//               <span className="grir-stat-value">
//                 <AnimatedCount target={s.value} isFloat={s.isFloat} />
//                 {s.suffix || ''}
//               </span>
//               <span className="grir-stat-label">{s.label}</span>
//             </div>
//           </motion.div>
//         ))}
//       </motion.div>

//       {/* ── Pending alert ── */}
//       <AnimatePresence>
//         {data.pending_reconciliations > 0 && (
//           <motion.div
//             className="grir-alert"
//             initial={{ opacity: 0, y: -10, height: 0 }}
//             animate={{ opacity: 1, y: 0,   height: 'auto' }}
//             exit={  { opacity: 0, y: -10,  height: 0 }}
//             transition={{ duration: 0.3 }}
//           >
//             <FiRefreshCw size={15} />
//             <span>{data.pending_reconciliations} reconciliation(s) pending.&nbsp;</span>
//             <button className="grir-link-btn" onClick={() => onNavigate('reconciliations')}>
//               Go to Reconciliations →
//             </button>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* ── Recent uploads ── */}
//       <motion.div
//         className="grir-card"
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ delay: 0.35, duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
//       >
//         <div className="grir-card-header">
//           <div className="grir-card-title">
//             <FiClock size={16} />
//             <span>Recent Uploads</span>
//           </div>
//           <button className="grir-link-btn" onClick={() => onNavigate('upload')}>
//             <FiUpload size={13} /> View All Uploads
//           </button>
//         </div>

//         {!data.recent_uploads || data.recent_uploads.length === 0 ? (
//           <div className="grir-empty">No uploads yet. Upload a GR or IR Excel file to get started.</div>
//         ) : (
//           <div className="grir-table-wrap">
//             <table className="grir-table">
//               <thead>
//                 <tr>
//                   <th>Filename</th><th>Type</th><th>Records</th>
//                   <th>Size</th><th>Status</th><th>Date</th>
//                 </tr>
//               </thead>
//               <motion.tbody variants={containerVariants} initial="hidden" animate="visible">
//                 {data.recent_uploads.map((u) => (
//                   <motion.tr key={u.id} variants={rowVariants}>
//                     <td className="grir-filename" title={u.filename}>{u.filename}</td>
//                     <td><span className={`grir-badge type-${u.file_type.toLowerCase()}`}>{u.file_type}</span></td>
//                     <td>{u.records_count}</td>
//                     <td>{formatSize(u.file_size)}</td>
//                     <td><span className={`grir-badge status-${u.status}`}>{u.status}</span></td>
//                     <td>{formatDate(u.upload_date)}</td>
//                   </motion.tr>
//                 ))}
//               </motion.tbody>
//             </table>
//           </div>
//         )}
//       </motion.div>
//     </div>
//   );
// };

// export default GRIRDashboard;



import React, { useState, useEffect, useCallback, useRef } from 'react';
import { motion, AnimatePresence, useMotionValue, useSpring } from 'framer-motion';
import {
  FiPackage, FiFileText, FiRefreshCw, FiPercent,
  FiUpload, FiClock, FiAlertCircle,
} from 'react-icons/fi';
import { useGrirApi } from './GrirApiContext';

const formatDate = (str) => {
  if (!str) return '—';
  return new Date(str).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};
const formatSize = (bytes) => {
  if (!bytes) return '—';
  return bytes > 1024 ? `${(bytes / 1024).toFixed(1)} KB` : `${bytes} B`;
};

/* Count-up animated number component */
const AnimatedCount = ({ target, isFloat = false }) => {
  const mv = useMotionValue(0);
  const spring = useSpring(mv, { stiffness: 80, damping: 25, mass: 1.2 });
  const [display, setDisplay] = useState('0');
  const ref = useRef(false);

  useEffect(() => {
    if (!ref.current) {
      ref.current = true;
      const t = parseFloat(target) || 0;
      mv.set(t);
    }
  }, [target, mv]);

  useEffect(() => {
    return spring.on('change', (v) => {
      setDisplay(isFloat ? v.toFixed(2) : Math.round(v).toLocaleString());
    });
  }, [spring, isFloat]);

  return <span>{display}</span>;
};

/* Stagger container */
const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1, delayChildren: 0.1 } },
};
const cardVariants = {
  hidden: { opacity: 0, y: 30, scale: 0.94 },
  visible: { opacity: 1, y: 0, scale: 1, transition: { type: 'spring', stiffness: 220, damping: 20 } },
};
const rowVariants = {
  hidden: { opacity: 0, x: -15, scale: 0.98 },
  visible: { opacity: 1, x: 0, scale: 1, transition: { type: 'spring', stiffness: 260, damping: 25 } },
};

const GRIRDashboard = ({ onNavigate }) => {
  const { getDashboard } = useGrirApi();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(() => {
    setLoading(true);
    setError('');
    getDashboard()
      .then(setData)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) {
    return (
      <div className="grir-loading">
        <div className="grir-spinner" />
        <span>Loading dashboard…</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="grir-error">
        <FiAlertCircle size={28} />
        <span>{error}</span>
        <button onClick={load}>Retry</button>
      </div>
    );
  }

  if (!data) return null;

  const rate = parseFloat(data.reconciliation_rate) || 0;
  const stats = [
    { label: 'Total GR Records', value: data.total_gr_records, icon: <FiPackage size={21} />, color: '#5b5fc7', bg: 'rgba(91,95,199,0.12)', isFloat: false },
    { label: 'Total IR Records', value: data.total_ir_records, icon: <FiFileText size={21} />, color: '#0099b0', bg: 'rgba(0,153,176,0.12)', isFloat: false },
    { label: 'Reconciliation Runs', value: data.total_reconciliations, icon: <FiRefreshCw size={21} />, color: '#7c3aed', bg: 'rgba(124,58,237,0.12)', isFloat: false },
    { label: 'Match Rate', value: rate, icon: <FiPercent size={21} />, color: '#059669', bg: 'rgba(5,150,105,0.12)', isFloat: true, suffix: '%' },
  ];

  return (
    <div className="grir-dashboard">
      {/* ── Stat cards ── */}
      <motion.div
        className="grir-stats-grid"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {stats.map((s) => (
          <motion.div key={s.label} className="grir-stat-card" variants={cardVariants}>
            <div className="grir-stat-icon" style={{ background: s.bg, color: s.color }}>
              {s.icon}
            </div>
            <div className="grir-stat-info">
              <span className="grir-stat-value">
                <AnimatedCount target={s.value} isFloat={s.isFloat} />
                {s.suffix || ''}
              </span>
              <span className="grir-stat-label">{s.label}</span>
            </div>
          </motion.div>
        ))}
      </motion.div>

      {/* ── Pending alert ── */}
      <AnimatePresence>
        {data.pending_reconciliations > 0 && (
          <motion.div
            className="grir-alert"
            initial={{ opacity: 0, y: -10, height: 0 }}
            animate={{ opacity: 1, y: 0, height: 'auto' }}
            exit={{ opacity: 0, y: -10, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            <FiRefreshCw size={15} />
            <span>{data.pending_reconciliations} reconciliation(s) pending.&nbsp;</span>
            <button className="grir-link-btn" onClick={() => onNavigate('reconciliations')}>
              Go to Reconciliations →
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      {/* ── Recent uploads ── */}
      <motion.div
        className="grir-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.35, duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="grir-card-header">
          <div className="grir-card-title">
            <FiClock size={16} />
            <span>Recent Uploads</span>
          </div>
          <button className="grir-link-btn" onClick={() => onNavigate('upload')}>
            <FiUpload size={13} /> View All Uploads
          </button>
        </div>

        {!data.recent_uploads || data.recent_uploads.length === 0 ? (
          <div className="grir-empty">No uploads yet. Upload a GR or IR Excel file to get started.</div>
        ) : (
          <div className="grir-table-wrap">
            <table className="grir-table">
              <thead>
                <tr>
                  <th>Filename</th><th>Type</th><th>Records</th>
                  <th>Size</th><th>Status</th><th>Date</th>
                </tr>
              </thead>
              <motion.tbody variants={containerVariants} initial="hidden" animate="visible">
                {data.recent_uploads.map((u) => (
                  <motion.tr key={u.id} variants={rowVariants}>
                    <td className="grir-filename" title={u.filename}>{u.filename}</td>
                    <td><span className={`grir-badge type-${u.file_type.toLowerCase()}`}>{u.file_type}</span></td>
                    <td>{u.records_count}</td>
                    <td>{formatSize(u.file_size)}</td>
                    <td><span className={`grir-badge status-${u.status}`}>{u.status}</span></td>
                    <td>{formatDate(u.upload_date)}</td>
                  </motion.tr>
                ))}
              </motion.tbody>
            </table>
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default GRIRDashboard;
